import { useProductVolumePricingContext } from '../ProductVolumePricingContext'
import { useGetDiscountRanges } from '../ProductVolumePricingModal/useGetDiscountRanges'

export const useProductAddToCartQuantitySelectionDiscountBadgeData = (
  selectionValue: number,
): { discount?: number; quantity?: number } => {
  const {
    quantitySelectionControls: { quantity },
    volumeBasedPrices,
  } = useProductVolumePricingContext()

  const currentQuantity = quantity
  const ranges = useGetDiscountRanges(volumeBasedPrices)

  const getDiscountPercentage = (value: number): number | undefined => {
    const discount = ranges.find((range) =>
      range.rangeEnd === undefined
        ? value >= range.rangeStart
        : value >= range.rangeStart && value <= range.rangeEnd,
    )

    return discount ? discount.discountPercentage : undefined
  }

  for (const volumePrice of volumeBasedPrices) {
    if (
      currentQuantity &&
      volumePrice.quantityThreshold &&
      volumePrice.discountPercentage !== null
    ) {
      return {
        discount: getDiscountPercentage(selectionValue),
        quantity: volumePrice.quantityThreshold,
      }
    }
  }

  return {
    discount: undefined,
    quantity: undefined,
  }
}
